import { t } from 'i18next';
import { UseFormSetError, FieldValues } from 'react-hook-form';
import { isValidEmailBraze } from 'utils/braze';
import { hasCharsForNames } from 'utils/string';
import { INPUT_NAMES } from './inputNames';
import { GsDate } from 'utils';

export const validationHandler = (
  setError: UseFormSetError<FieldValues>,
  value: string,
  inputName: string,
): boolean => {
  if (!value) {
    setError(inputName, {
      message: String(
        t(`customizeCard.formInputs.formErrors.${inputName}.empty`),
      ),
    });
    return true;
  }
  if (inputName === INPUT_NAMES.NAME && !hasCharsForNames(value)) {
    setError(inputName, {
      message: String(
        t(`customizeCard.formInputs.formErrors.${inputName}.wrong`),
      ),
    });
    return true;
  }
  if (inputName === INPUT_NAMES.EMAIL && !isValidEmailBraze(value)) {
    setError(inputName, {
      message: String(
        t(`customizeCard.formInputs.formErrors.${inputName}.wrong`),
      ),
    });
    return true;
  }
  if (inputName === INPUT_NAMES.DATE && GsDate(value).isBefore(GsDate())) {
    setError(inputName, {
      message: String(
        t(`customizeCard.formInputs.formErrors.${inputName}.wrong`),
      ),
    });
    return true;
  }
  return false;
};
